export const states = [
    { value: "NI", description: 'Não Informado' },
    { value: "AC", description: 'Acre' },
    { value: "AL", description: 'Alagoas' },
    { value: "AP", description: 'Amapá'  },
    { value: "AM", description: 'Amazonas' },
    { value: "BA", description: 'Bahia' },
    { value: "CE", description: 'Ceará' },
    { value: "DF", description: 'Distrito Federal' },
    { value: "ES", description: 'Espirito Santo' },
    { value: "GO", description: 'Goiás'  },
    { value: "MA", description: 'Maranhão' },
    { value: "MS", description: 'Mato Grosso do Sul' },
    { value: "MT", description: 'Mato Grosso' },
    { value: "MG", description: 'Minas Gerais' },
    { value: "PA", description: 'Pará' },
    { value: "PB", description: 'Paraiba' },
    { value: "PR", description: 'Paraná'  },
    { value: "PE", description: 'Pernambuco'  },
    { value: "PI", description: 'Piauí'  },
    { value: "RJ", description: 'Rio de Janeiro' },
    { value: "RN", description: 'Rio grande do norte' },
    { value: "RS", description: 'Rio grande do sul' },
    { value: "RO", description: 'Rondônia' },
    { value: "RR", description: 'Roraima'  },
    { value: "SC", description: 'Santa Catarina' },
    { value: "SP", description: 'São Paulo' },
    { value: "SE", description: 'Sergipe' },
    { value: "TO", description: 'Tocantíns'  },
];